import React from 'react';
import { signatureHotDogs, sidesAndDrinks } from '../mock';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Flame, Leaf, Moon, Star } from 'lucide-react';

const itemIcons = {
  flame: Flame,
  leaf: Leaf,
  moon: Moon,
  star: Star
};

const Menu = () => {
  return (
    <section id="menu" className="py-24 px-6 bg-black relative overflow-hidden">
      {/* Decorative grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            <span className="text-cyan-400">Menu</span>
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Each creation is crafted with care and launched with flavor
          </p>
        </div>

        {/* Signature Hot Dogs */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-orange-500 mb-8 text-center">Signature Hot Dogs</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {signatureHotDogs.map((item) => (
              <Card 
                key={item.id}
                className="group bg-gradient-to-br from-gray-900 to-gray-800 border-gray-700 hover:border-orange-500/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/20 overflow-hidden relative"
              >
                {/* Glow effect on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-500/0 to-cyan-400/0 group-hover:from-orange-500/5 group-hover:to-cyan-400/5 transition-all duration-300"></div>
                
                {/* Popular Badge */}
                {item.popular && (
                  <div className="absolute top-4 right-4 z-10">
                    <Badge className="bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold px-3 py-1 flex items-center gap-1 shadow-lg">
                      <Flame className="w-4 h-4" />
                      Fan Favorite
                    </Badge>
                  </div>
                )}
                
                <CardHeader className="relative">
                  <div className="flex items-start justify-between gap-4 mb-3">
                    <CardTitle className="text-2xl text-white group-hover:text-orange-500 transition-colors duration-300 flex items-center gap-3">
                      {(() => {
                        const Icon = itemIcons[item.icon];
                        return Icon ? <Icon className="w-6 h-6 text-cyan-400 shrink-0" /> : null;
                      })()}
                      {item.name}
                    </CardTitle>
                    <span data-testid={`menu-price-${item.id}`} className="text-2xl font-bold text-orange-500 shrink-0">{item.price}</span>
                  </div>
                  <CardDescription className="text-gray-400 text-base leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardHeader>
                
                <CardContent className="relative">
                  <div className="h-1 w-full bg-gradient-to-r from-orange-500 via-cyan-400 to-orange-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Sides and Drinks */}
        <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 rounded-2xl p-8 border border-gray-700">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Sides */}
            <div>
              <h3 className="text-2xl font-bold text-orange-500 mb-6 flex items-center gap-3">
                <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
                Sides
              </h3>
              <div className="space-y-3">
                {sidesAndDrinks.filter(item => item.category === 'Sides').map((item) => (
                  <div key={item.id} className="p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-between">
                    <span className="text-white font-medium text-lg">{item.name}</span>
                    <span className="text-orange-500 font-bold text-lg">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Drinks */}
            <div>
              <h3 className="text-2xl font-bold text-cyan-400 mb-6 flex items-center gap-3">
                <span className="w-2 h-2 bg-cyan-400 rounded-full"></span>
                Drinks
              </h3>
              <div className="space-y-3">
                {sidesAndDrinks.filter(item => item.category === 'Drinks').map((item) => (
                  <div key={item.id} className="p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-between">
                    <span className="text-white font-medium text-lg">{item.name}</span>
                    <span className="text-orange-500 font-bold text-lg">{item.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;